import classNames from "classnames"
import type { ReactNode } from "react"
import React from "react"

import type { ImgixParams } from "../../../helpers/image"
import type { PNImageProps } from "../PNImage/PNImage"
import { PNImage } from "../PNImage/PNImage"
export const imgixCroppedHeroImage: ImgixParams = { fit: "crop", w: 640, h: 764 }
export type HeroContainerProps = {
  children: ReactNode
  image?: PNImageProps["src"]
  imageClassName?: string
  placeholder?: PNImageProps["placeholder"]
  fallbackBlurDataURL?: PNImageProps["fallbackBlurDataURL"]
  imgixParams?: ImgixParams
  hideImageOnMobile?: boolean
  className?: string
}
export const HeroContainer = ({
  children,
  image,
  hideImageOnMobile = true,
  imgixParams,
  placeholder,
  fallbackBlurDataURL,
  imageClassName,
  className,
}: HeroContainerProps) => (
  <header
    className={classNames(
      "relative mx-auto flex w-full max-w-screen-xl flex-col md:min-h-[724px] lg:pr-16",
      className,
    )}>
    <div className="relative z-1 mx-auto flex size-full max-w-screen-xl flex-1 flex-col px-6 pb-[84px] pt-10 md:items-start md:pt-28">
      <div className="md:w-2/3 lg:w-2/4 xl:w-1/2">
        <div className="flex size-full max-w-full flex-col pr-0 md:pr-2.5">{children}</div>
      </div>
    </div>
    <PNImage
      src={image}
      width={640}
      height={764}
      imgixParams={imgixParams}
      priority
      loading="eager"
      placeholder={placeholder}
      fallbackBlurDataURL={fallbackBlurDataURL}
      data-chromatic="ignore"
      className={classNames(
        hideImageOnMobile && "hidden",
        "right-0 top-0 mr-0 h-full overflow-hidden object-cover md:absolute md:flex md:w-1/4 lg:w-1/3 xl:mr-6 xl:w-1/2",
        imageClassName,
      )}
    />
  </header>
)
